import(/* webpackMode: "eager" */ "/app/components/CookieConsent/CookieConsentView.tsx");
import(/* webpackMode: "eager" */ "/app/components/CouponBar/CouponBar.tsx");
import(/* webpackMode: "eager" */ "/app/components/Toast/ToastUtils.tsx");
import(/* webpackMode: "eager" */ "/app/components/Toast/ToastView.tsx");
import(/* webpackMode: "eager" */ "/app/lib/apollo/ApolloWrapper.tsx");
import(/* webpackMode: "eager" */ "/app/utils/providers/LanguageSwitcherProvider/LanguageSwitcherProvider.tsx")